import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'
import EstornarItemPedidoInput from '@/core/apiclient/item-pedido/estorno/models/EstornarItemPedidoInput'

export default {
	async [actionTypes.ITEM_PEDIDO.ESTORNO.ESTORNAR.ESTORNAR_ITEM]({ state }, cancelarDocumentoProcessoDigital) {
		state.form.cancelarDocumentosJuntados = cancelarDocumentoProcessoDigital
		let estornarItemPedidoInput = new EstornarItemPedidoInput(
			getIdsItensPedido(state),
			state.form.justificativa,
			state.form.quantidadeEstorno,
		)
		estornarItemPedidoInput.cancelarDocumentosJuntados = state.form.cancelarDocumentosJuntados
		await api.itemPedidoEstorno.estornar(estornarItemPedidoInput)
	},
}

function getIdsItensPedido(state) {
	return state.form.itensPedido.map((item) => item.idItemPedido)
}
